import { useEffect } from "react";

export default function SentryComponent() {
  useEffect(() => {
    // const timer = setTimeout(async () => {
    // loadSentry();
    async function loadData() {
      const Sentry = await import("@sentry/browser");
      const { Integrations } = await import("@sentry/tracing");
      if (process.env.REACT_APP_TARGET === "prod") {
        Sentry.init({
          dsn:
            "https://99723c78d3184144981488cee2640252@o557432.ingest.sentry.io/5689676",
          release: process.env.REACT_APP_SENTRY_RELEASE,
          integrations: [new Integrations.BrowserTracing()],
          // We recommend adjusting this value in production, or using tracesSampler
          // for finer control
          tracesSampleRate: 1.0,
        });
      }
    }
    loadData();
    // }, 1000);
    // return () => clearTimeout(timer);
  }, []);

  return null;
}
